import React from 'react';

export default function GetBooleanFromEnv(string: string) {
    return string == 'true' ? true : false;
}
